type Style = { bg: string; fg: string; label: string };

const STYLE: Record<string, Style> = {
  stock_in: { bg: "#E8F7EE", fg: "#16A34A", label: "IN" },
  stock_out: { bg: "#FEE2E2", fg: "#DC2626", label: "OUT" },
  transfer_out: { bg: "#EEF2FF", fg: "#4338CA", label: "TFR↗" },
  transfer_in: { bg: "#E0F2FE", fg: "#0369A1", label: "TFR↙" },
  inventory_adjust: { bg: "#FEF3C7", fg: "#D97706", label: "ADJ" },
  tiktok_sale: { bg: "#FCE7F3", fg: "#9D174D", label: "TIKTOK" },
  shopify_sale: { bg: "#CCFBF1", fg: "#0F766E", label: "SHOPIFY" },
  reconcile_check: { bg: "#F3E8FF", fg: "#7E22CE", label: "SYNC" },
  reconcile_correction: { bg: "#F3E8FF", fg: "#7E22CE", label: "FIX" },
};

const FALLBACK: Style = { bg: "#F4F1EA", fg: "#3E4255", label: "—" };

export function EventBadge({ type }: { type: string }) {
  const s = STYLE[type] ?? { ...FALLBACK, label: type.slice(0, 5).toUpperCase() };
  return (
    <span
      style={{
        background: s.bg,
        color: s.fg,
        fontSize: 9,
        fontWeight: 800,
        padding: "3px 6px",
        borderRadius: 5,
        letterSpacing: "0.04em",
        display: "inline-flex",
        alignItems: "center",
        height: 18,
        whiteSpace: "nowrap",
      }}
    >
      {s.label}
    </span>
  );
}
